export enum SegmentProperty {
  EMAIL = 'email',
  REDIRECTED_FROM = 'redirected_from',
  BILLING_PLAN = 'billing_plan',
  LINE_OF_BUSINESS = 'line_of_business',
  PAYING_CUSTOMER = 'paying_customer',
  MEETING_ID = 'meeting_id',
  MEETING_NAME = 'meeting_name',
  MEETING_DATE = 'meeting_date',
  ONBOARDING_NEXT_STEP = 'onboarding_next_step',
  ONBOARDING_COMPLETED = 'onboarding_completed'
}
